var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	2427: {
		fallback: () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	1263: {
		fallback: () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	147: {
		fallback: () => (__webpack_require__.e(303).then(() => (() => (__webpack_require__(6303))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "antd",

	},
	5160: {
		fallback: () => (__webpack_require__.e(882).then(() => (() => (__webpack_require__(7882))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"55": [
		147
	],
	"263": [
		1263
	],
	"806": [
		5160
	],
	"808": [
		2427
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}